import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {isCodeViewEnabled} from '@github-ui/repo-app-flags'

// Code View's routes can be registered under the unified `repo` app when the
// `repo_app_code_view` flag is on. The app's identity stays `code-view`, but in
// that case its query keys must use `repo` so they match the running app. The
// resolver is only evaluated when a query key is built (runtime), so it can
// safely read the flag.
export const codeViewAppBuilder = DataRouterApplicationBuilder.create('code-view', {
  queryKeyAppName: () => (isCodeViewEnabled() ? 'repo' : 'code-view'),
})
